log = require 'loglevel'
Tween = require 'tween'
BaseButton = require 'BaseButton'
deviceManager = require 'deviceManager'
layoutManager = require 'layoutManager'
gameModel = require 'gameModel'
imageModel = require 'imageModel'


class NotificationView extends PIXI.Container

  name: 'NotificationView'
  completed: false
  overlayAlpha: 0.9
  buttons: []
  offset: 100
  padding: 56

  style:
    fontSize: 28
    fontWeight: 100
    fill: "#FFFFFF"
    align: "center"
    lineHeight: 32
    wordWrap: true
    wordWrapWidth: 280

  msgStyle:
    fontSize: 13
    fontWeight: 100
    align: "center"
    fill: "#FFFFFF"
    lineHeight: 17
    wordWrap:  true
    wordWrapWidth: 280

  #----------------------------------------------

  constructor: ->
    super()
    vp = deviceManager.getViewport()

    @style.fontFamily = gameModel.getFont()
    @msgStyle.fontFamily = gameModel.getFont()

    @addBg()

    @inner = new PIXI.Container()
    @inner.position.set gameModel.stageX, gameModel.stageY
    @addChild @inner

  #----------------------------------------------

  addBg: ->
    @overlay = new PIXI.Graphics()
    @overlay.beginFill(0x000000)
    @overlay.drawRect(0,0,gameModel.rendererWidth, gameModel.rendererHeight)
    @overlay.endFill()
    @overlay.alpha = 0
    @addChildAt(@overlay,0)

  #----------------------------------------------

  setup: (title, message, actions) ->

    @completed = false
    @showOverlay =>
      @addText(title, message)
      @addButtons(actions)
      @resize()
      @completed = true

  #----------------------------------------------

  hide: (cb) ->

    # next tick
    setTimeout( =>

      if @text?
        @text.visible = false
      @removeButtons()

      @hideOverlay =>
        cb() if cb?
    ,1)

  #----------------------------------------------

  addText: (title, msg) ->

    if @text?
      @updateText title, msg
      @text.visible = true
      return

    @text = new PIXI.Container()
    @inner.addChild @text

    title = __t.str(title)
    msg = __t.str(msg)

    @titleText = new PIXI.Text title, @style
    @titleText.y = 45
    @text.addChild @titleText
    @titleText.clarify()
    @titleText.centerX(gameModel.gameWidth)

    @messageText = new PIXI.Text msg, @msgStyle
    @messageText.y = 110
    @text.addChild @messageText
    @messageText.clarify()
    @messageText.centerX(gameModel.gameWidth)

  #----------------------------------------------

  updateText: (title, msg) ->
    @titleText.text = __t.str(title)
    @titleText.clarify()
    @titleText.centerX(gameModel.gameWidth)
    @updateMsg(msg)

  #----------------------------------------------

  updateMsg: (msg) ->
    return unless @messageText?
    @messageText.text = __t.str(msg)
    @messageText.clarify()
    @messageText.centerX(gameModel.gameWidth)

  #----------------------------------------------

  addButtons: (actions) ->

    @removeButtons()

    actions = actions.reverse()

    place = 0
    for action, i in actions
      if @addButton action, place, i, actions.length
        place++

  #----------------------------------------------

  addButton: (action, place, i, total) ->
    log.info @constructor.name, 'addButton',action, place

    return false unless @canPerformAction action.action

    action.remainActive = true

    if i is total-1
      action.type = 'primary'
      action.buttonImage = imageModel.buttonImage
      action.buttonHoverImage = imageModel.buttonHoverImage
    else
      action.type = 'secondary'
      action.buttonImage = imageModel.buttonSecondaryImage
      action.buttonHoverImage = imageModel.buttonSecondaryHoverImage

    button =  new BaseButton(action)

    x = (gameModel.gameWidth-button.width) /2
    y = (gameModel.rendererHeight - @offset) - (@padding * place)

    button.order = place
    button.position.set(x,y)
    @inner.addChild button

    @buttons.push button

    return true

  #----------------------------------------------

  removeButtons: (cb) ->
    for button in @buttons
      button.removeSelf()

    @buttons = []

  #----------------------------------------------

  showOverlay: (cb) ->

    to =
      alpha: @overlayAlpha
      onComplete: cb

    Tween.to(@overlay, 300/1000, to)

  #----------------------------------------------

  hideOverlay: (cb) ->
    if not @overlay?
      cb() if cb?
      return

    to =
      alpha: 0
      onComplete: =>
        cb() if cb?

    Tween.to(@overlay, 300/1000, to)

  # -------------------------------------------

  resize: ->

    @removeChild @overlay
    @addBg()

    if @parent?
      @overlay.alpha = @overlayAlpha
    else
      @overlay.alpha = 0

    if @inner?
      @inner.position.set gameModel.stageX, gameModel.stageY

    if @buttons?
      for button in @buttons
        layoutManager.repositionY button

  # -------------------------------------------

  canPerformAction: (action) ->

    switch action
      when 'cashier'
        return false if not gameModel.getCashierUrl()?
      when 'history'
        return false if not gameModel.getHistoryUrl()?
      when 'home'
        return false if not gameModel.getHomeUrl()?
      when 'buy-more'
        return false if not gameModel.getBuyMoreUrl()?

    return true

  # -------------------------------------------

module.exports = NotificationView


// WEBPACK FOOTER //
// ./coffee/view/notification-view.coffee